import React from "react";
import {LogoComponent} from "../logo/LogoComponent";
import {isMobileDevice} from "../../../utils/WindowUtils";
import {ThemedLottiePlayerComponent} from "../lottie-player/ThemedLottiePlayerComponent";

interface ProcessingComponentProps {
    loadingAnimation: string
    successAnimation: string
    success: boolean
    logo?: boolean
    noText?: boolean
}

const ProcessingComponent: React.FC<ProcessingComponentProps> = ({loadingAnimation, successAnimation, success, logo, noText}: ProcessingComponentProps) => {

    return (
        <div className={`background background-processing general-container ${noText ? 'processing-notext-container': ''}`}>
            <div className={`${logo && isMobileDevice() ? 'header-logo-container' : logo ? 'header-logo-container-headless' : ''} width-full flex-center`}>
                {logo && isMobileDevice() ? <LogoComponent/> : ('')}
            </div>
            <div className={`flex-center`}>
                { success ? (
                    <ThemedLottiePlayerComponent animation={successAnimation}/>
                ) : (
                    <ThemedLottiePlayerComponent animation={loadingAnimation}/>
                )
                }
            </div>
            {
                !noText && <div className={`width-full flex-center font-md processing-text-color`}>
                    {success ? <>Analysis complete</> : <>Analysing...</>}
                </div>
            }

        </div>
    )
}

export default ProcessingComponent